module.exports = __webpack_public_path__ + "static/images/biditem7_caad2196.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem7.png
// module id = 246
// module chunks = 1